var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',_vm._g(_vm._b({attrs:{"centered":"","lg":"","dialog-cls":_vm.$style.overlay,"body-cls":"p-0"}},'Modal',_vm.$props,false),_vm.$listeners),[_c('iframe',{ref:"iframe",staticClass:"w-100",class:_vm.$style.iframe,attrs:{"src":_vm.value ? _vm.url : false,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }